var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._g({staticClass:"mb-2"},_vm.$listeners),[(_vm.$slots.title)?_c('v-card-title',[_vm._t("title")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }